// httpConfig.interceptor.ts
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, EMPTY, catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { CoreService } from '../core.service';
import { ErrorMessageService } from '../error-message.service';

@Injectable({ providedIn: 'root' })
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly coreService: CoreService,
    private readonly errorMessageService: ErrorMessageService,
    private readonly router: Router
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Add API-specific logic
    if (request.url.includes(`${environment.apiUrl}/v1`)) {
      request = this.addHeaders(request);
    }

    return next
      .handle(request)
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));

  }

  private addHeaders(request: HttpRequest<any>): HttpRequest<any> {
    // Add AppVersion header
    request = request.clone({
      setHeaders: { AppVersion: environment.appVersion },
    });

    // Add Authorization header if token exists
    const token = localStorage.getItem('ekapyIntegrationSystemDtToken');
    if (token) {
      const parsedToken = JSON.parse(token);
      if (parsedToken) {
        request = request.clone({
          setHeaders: { Authorization: `Bearer ${parsedToken}` },
        });
      }
    }

    return request;
  }

  private handleError(error: HttpErrorResponse): Observable<never> {

    if (error?.status === 401) {
      if (this.router.url.includes('/login')) {
        this.showError(error?.error ?? 'Authentication failed');
      } else {
        this.authService.logout();
      }
    } else if (error?.status === 404) {
      this.showError(error?.error?.Message ?? error?.error ?? 'Resource not found');
    } else {
      this.showError(error?.error ?? 'An unexpected error occurred');
    }

    return throwError(() => new Error(error?.error));
  }

  private showError(error: any): void {
    const errorMessage = this.errorMessageService.getErrorMessage(error);
    this.coreService.showError(errorMessage);
  }
}
